import { BaseControlledModal } from "../../../../../../common/components/base_controlled_modal";

/**
 * AprovadoresColetaPrecoModal
 */

type Props = {
  open: boolean;
  saving: boolean;
  loading: boolean;
  onClose: () => void;
  onSubmit: () => void;
};

export const AprovadoresColetaPrecoModal = ({
  open,
  saving,
  loading,
  onClose,
  onSubmit,
}: Props) => {
  return (
    <BaseControlledModal
      open={open}
      saving={saving}
      loading={loading}
      title="Selecionar Aprovadores"
      onClose={onClose}
      onSubmit={onSubmit}>
    </BaseControlledModal>
  );
}